import { render, staticRenderFns } from "./StempelLogic.vue?vue&type=template&id=46207897&scoped=true"
import script from "./StempelLogic.vue?vue&type=script&lang=js"
export * from "./StempelLogic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46207897",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46207897')) {
      api.createRecord('46207897', component.options)
    } else {
      api.reload('46207897', component.options)
    }
    module.hot.accept("./StempelLogic.vue?vue&type=template&id=46207897&scoped=true", function () {
      api.rerender('46207897', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/stempelkarte/StempelLogic.vue"
export default component.exports